module.exports = __webpack_public_path__ + "img/table-no-data-dark.8b9cef26.svg";